import type { CustomField } from "@/schema"

type UserOption = {
  id: string
}

export function getUserReferenceAllowedUserIds(customField: CustomField): string[] | undefined {
  return customField.user_reference_allowed_user_ids ?? customField.options?.user_reference_allowed_user_ids
}

export function filterUsersForUserReferenceField<TUser extends UserOption>(
  customField: CustomField,
  users: TUser[] | undefined
): TUser[] {
  const availableUsers = users ?? []
  const allowedUserIds = getUserReferenceAllowedUserIds(customField)

  if (!allowedUserIds?.length) return availableUsers

  const allowed = new Set(allowedUserIds)
  return availableUsers.filter((user) => allowed.has(user.id))
}
